import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useShoppingCart } from "../../context/ShoppingCartContext";
import { CURRENCY } from "../../enumerations/currencyEnum";
import ProductSpec from "../ProductSpec";
import Cart from "./icons/Cart";
import styles from "./style.module.scss";

const VolumeCard = (props: any) => {
  const { t } = useTranslation();
  const { updateCart } = useShoppingCart();
  const [isAddedToCart, setIsAddedToCart] = useState(false);
  const [count, setCount] = useState(1);
  const [timeoutInstance, setTimeoutInstance] = useState<any>(null);
  const addedToCartBtnStyle = {
    background: "rgba(0, 0, 0, 0.90)",
    borderColor: "transparent",
    color: "var(--green)",
  };

  const onClickAddCart = () => {
    updateCart(props.id, count);
    setIsAddedToCart(true);

    const timeout = setTimeout(() => {
      setIsAddedToCart(false);
    }, 1500);
    setTimeoutInstance(timeout);
  };

  useEffect(() => {
    setCount(1);

    return () => {
      if (timeoutInstance) {
        clearTimeout(timeoutInstance);
        setTimeoutInstance(null);
      }
    };
  }, []);

  return (
    <div className={styles.cardContainer}>
      <img className={styles.imgCard} src={props.img} alt="travel_img" />
      <div className={styles.topText}>
        <div className={styles.days}>
          {t("normal.days", { days: props.days })}
        </div>
        <div className={styles.volume}>
          {ProductSpec(t, props.network_volume, props.type)}
        </div>
      </div>
      <div className={styles.country}>{props.country}</div>
      <div className={styles.bottomArea}>
        <div className={styles.left}>
          <div className={styles.desc}>{t("hiddebStore.volumeCard.desc1")}</div>
          <div className={styles.desc}>{t("hiddebStore.volumeCard.desc2")}</div>
        </div>
        <div className={styles.right}>
          <div className={styles.discount}>
            {CURRENCY.TW}
            {props.sell_price}
          </div>
          <div className={styles.price}>{props.store_price ?? 0}</div>
        </div>
      </div>

      <div
        className={styles.addToCart}
        onClick={onClickAddCart}
        style={isAddedToCart ? addedToCartBtnStyle : {}}
      >
        <Cart color={isAddedToCart ? "var(--green)" : "var(--grey900)"} />
        {t("normal.addinto.cart")}
      </div>
    </div>
  );
};

export default VolumeCard;
